import React from "react";
import { Dropdown, Menu } from "antd";
import NavItem from "./NavItem";
import { NavItemConfig } from "../Siderbar.constant";

type Props = {
    parentClass?: string,
    children: React.ReactNode,
    TitleComp: React.ReactNode,
    items: NavItemConfig[],
    isActiveKey: string,
    closeOpenMenu?: () => void;
    handleItemClick: (item: NavItemConfig) => void,
    disableDropdown?: boolean,
    disableOptions?: boolean
}

const CustomDropdown = ({ children, TitleComp, parentClass, isActiveKey, items, handleItemClick, closeOpenMenu, disableDropdown = false, disableOptions = false } : Props) => {
    return (
        <Dropdown disabled={disableDropdown} trigger={["click"]} placement="bottomLeft" align={{ offset: [40, -5] }} onVisibleChange={() => closeOpenMenu?.()}
            overlay={(
                <div className={`custom-dropdown ${parentClass || ""}`}>
                    {TitleComp}
                    {TitleComp && <div className="divider"></div>}
                    <Menu key={items.length}>
                        {items.map((item, index) => {
                            return <NavItem {...{ item, isActive: isActiveKey === item.path, isOpen: false, hasChildren: false, onClick: () => handleItemClick(item), disableOptions }} key={`${item.key}-${index}`} />
                        })}
                    </Menu>
                </div>
            )}>
            {children}
        </Dropdown>
    );
};

export default CustomDropdown;